<template>
  <v-dialog :value="value" @click:outside="close" :width="defaultDialogWidth" persistent>
    <v-card>
      <div class="py-4 px-5">
        <h5 class="title">Добавить в черный список</h5>
      </div>
      <v-card-text>
        <validation-observer ref="formObs" v-slot="{handleSubmit}">
          <form @submit.prevent="handleSubmit(() => $emit('submit', comment))">
            <custom-text-textarea
                name="Коментарии"
                rules="required"
                placeholder="Причина добавление в черный список..."
                v-model="comment"
            ></custom-text-textarea>
            <v-btn type="submit" color="error" width="100%">Добавить в черный список</v-btn>
          </form>
        </validation-observer>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {defaultDialogWidth} from "@/utils/constants";

export default {
  name: "AddToBlackListDialog",
  props: {
    value: {
      type: Boolean
    },
  },
  data() {
    return {
      comment: '',
      defaultDialogWidth
    }
  },
  methods: {
    close() {
      this.$emit('input', false)
      this.comment = ''
      this.$refs.formObs.reset()
    }
  }
}

</script>

<style scoped>

</style>